// extracted by mini-css-extract-plugin
export default {"total":"NetworkPricesResultBar_total__nSVjW"};